/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Source_LabelInputs */

const en_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Event Group`)
};

const fr_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements source`)
};

const de_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellereignisgruppe`)
};

const it_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi di origine`)
};

const ru_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа событий источника`)
};

const es_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos de origen`)
};

const zh_cn2_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源事件组`)
};

const ja_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースイベントグループ`)
};

const hi_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत घटना समूह`)
};

const pt_pt2_segment_event_group_source_label = /** @type {(inputs: Segment_Event_Group_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos de Origem`)
};

/**
* | output |
* | --- |
* | "Source Event Group" |
*
* @param {Segment_Event_Group_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_source_label = /** @type {((inputs?: Segment_Event_Group_Source_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Source_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_source_label(inputs)
	if (locale === "de") return de_segment_event_group_source_label(inputs)
	if (locale === "it") return it_segment_event_group_source_label(inputs)
	if (locale === "ru") return ru_segment_event_group_source_label(inputs)
	if (locale === "es") return es_segment_event_group_source_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_source_label(inputs)
	if (locale === "ja") return ja_segment_event_group_source_label(inputs)
	if (locale === "hi") return hi_segment_event_group_source_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_source_label(inputs)
	return en_segment_event_group_source_label(inputs)
});